import type { FC } from 'react';

import { useMediaQuery } from '@/modules/perseo-billing/ui/react/src/ui-hooks';

type PaymentMethodProps = {
  title: string;
  subcomponent?: React.ReactNode;
  isHeader?: boolean;
};

export const Title: FC<PaymentMethodProps> = ({
  title,
  subcomponent,
  isHeader = false
}) => {
  const isMobile = useMediaQuery('lg');
  const className = getTitleClassName(isHeader, isMobile);
  return (
    <div className="co-flex co-flex-col co-w-full co-gap-16px lg:co-flex-row lg:co-justify-between">
      <p className={className} tabIndex={0} aria-label={title}>
        {title}
      </p>
      {subcomponent}
    </div>
  );
};

const getTitleClassName = (isHeader: boolean, isMobile: boolean) => {
  const headerTitle = 'co-text-h2 co-font-semibold';
  const desktopTitle = 'co-text-h2 co-font-semibold';
  const mobileTitle = 'co-text-h4 co-font-semibold';

  if (isHeader) {
    return headerTitle;
  }
  return isMobile ? mobileTitle : desktopTitle;
};
